// extracted by mini-css-extract-plugin
module.exports = {"tabSet":"TabSet_tabSet__1IgBi","divider":"TabSet_divider__2laVM","frame":"TabSet_frame__13US-","content":"TabSet_content__MeFp7"};